import {
  FilteredCustomerCloseData,
  OptedInCustomerCloseData,
} from '@ads-bread/shared/bread/codecs';

export const filterCustomerCloseDataCapacity = (
  customerCloseData: OptedInCustomerCloseData,
  canViewCapacity: boolean
): FilteredCustomerCloseData => {
  const { capacity, ...filteredCustomerCloseData } = customerCloseData;

  return canViewCapacity ? customerCloseData : filteredCustomerCloseData;
};
